import {useMutation} from 'react-query';
import {downloadFile} from '../../../app/pages/documents/api';

export const useDownloadFile = () => {
  return useMutation({
    mutationFn: downloadFile,
  });
};
